import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';

import { useAxiosWithAPI } from '../useAxiosWithAPI';

export type RoleHandoffCountryCode = 'ID' | 'MY' | 'SG' | 'TW' | 'VN';

type CreateRoleHandoffInput = {
  targetRole: 'CANDIDATE';
  countryCode: RoleHandoffCountryCode;
};

type CreateRoleHandoffResponse = {
  code: string;
  expiresIn: number;
};

export const requestRoleHandoff = async (
  axios: AxiosInstance,
  input: CreateRoleHandoffInput
): Promise<CreateRoleHandoffResponse> => {
  const response = await axios.post<{
    code: 'OK';
    data: CreateRoleHandoffResponse;
  }>('/v2/auth/role-handoffs', input);

  const handoff = response.data.data;
  if (!handoff?.code) {
    throw new Error('Role handoff code is missing');
  }

  return handoff;
};

export const useCreateRoleHandoff = () => {
  const axios = useAxiosWithAPI();
  const {
    mutateAsync: createRoleHandoff,
    isPending,
    error,
  } = useMutation({
    mutationFn: (input: CreateRoleHandoffInput) =>
      requestRoleHandoff(axios, input),
  });

  return {
    createRoleHandoff,
    isCreatingRoleHandoff: isPending,
    error,
  } as const;
};
